import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {FormattedDate, FormattedTime} from 'react-intl';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import ListActionItems from '../../List/ListActionItems';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import LoadingSpinner from '../../LoadingSpinner';
import AbstractTableView from '../../common/AbstractTableView';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';

class EventsList extends AbstractTableView {
  static propTypes = {
    ...AbstractTableView.propTypes,
    onClick: PropTypes.func.isRequired
  };

  confirmRemoveMessage = (
    <FormattedMessage
      id="event.remove"
      defaultMessage="Are you sure want to delete event?"
    />
  );

  render() {
    let {list, add, edit, items, hasMore, loading} = this.props;
    let records = list.map(id => items[id]);
    let {palette: {labelColor}, tableHeaderColumn} = this.context.muiTheme;
    let fixedColumn = {style: {width: 120, color: labelColor}};

    return (
      <div>
        <LoggedAppBar title='Events' isStatic/>
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                           style={{
                             backgroundColor: tableHeaderColumn.bgColor
                           }}
              >
                <TableRow>
                  <TableHeaderColumn style={{color: labelColor}}>Event Name</TableHeaderColumn>
                  <TableHeaderColumn style={{color: labelColor}}>Time</TableHeaderColumn>
                  <TableHeaderColumn {...fixedColumn}>Actions</TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {records.length > 0
                  ? records.map(({id, first_partc, second_partc, start_time, end_time}) => (
                    <TableRow key={id}>
                      <TableRowColumn>{this.renderEventName(first_partc, second_partc)}</TableRowColumn>
                      <TableRowColumn>{this.renderTime(start_time, end_time)}</TableRowColumn>

                      <TableRowColumn {...fixedColumn}>
                        <ListActionItems edit={edit}
                                         remove={this.props.delete}
                                         record={items[id]}
                                         confirmMessageLabel={this.confirmRemoveMessage}
                        />
                      </TableRowColumn>
                    </TableRow>
                  ))
                  : (<TableRow><TableRowColumn columnNumber={4}>Empty list</TableRowColumn></TableRow>)
                }
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>
        <AddButton onClick={add}/>
      </div>
    );
  }

  renderEventName(first_part, second_part) {
    return (
      <div>{first_part.name} VS {second_part.name}</div>
    );
  }

  renderTime(start_time, end_time) {
    return (
      <p>
        <FormattedDate value={start_time}/> <FormattedTime value={start_time}/> - <FormattedDate value={end_time}/> <FormattedTime value={end_time}/>
      </p>
    );
  }
}

export default EventsList;



// WEBPACK FOOTER //
// ./src/components/Events/EventsList/EventsList.jsx